module.exports = __webpack_public_path__ + "static/bg2-6afa249bf0ca8ef66eb222ebd954d0a4.jpg";